import { isPlatformBrowser } from "@angular/common";
import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(@Inject(PLATFORM_ID) private platformId: any) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const modifiedRequest = this.cloneRequestWithToken(req);
    return next.handle(modifiedRequest);
  }


  private cloneRequestWithToken(request: HttpRequest<any>): HttpRequest<any> {
    try {
      let practiceId: string | null = null;
      let practiceGuid: string | null = null;

      if (isPlatformBrowser(this.platformId)) {
        practiceId = localStorage.getItem('practiceId');
        practiceGuid = localStorage.getItem('practiceGuid');
      }

      if (practiceId) {
        return request.clone({
          setHeaders: {
            'PracticeId': practiceId
          }
        });
      }
      else {
        return request;
      }
    }
    catch (e) {
      console.log('🚀 AuthInterceptor Error!', e);
      return request;
    }
  }

}